<template>
  <FormButton
    data-bs-toggle="modal"
    data-bs-target="#group-edit-modal"
    class="truncate text-left"
  >
    <FontAwesomeIcon icon="layer-group" class="mr-4" /><slot></slot>
  </FormButton>
</template>
